import {Directive, HostBinding, HostListener} from '@angular/core';

@Directive({
  selector: '[appDropdown]'
})
export class DropdownDirective {
  @HostBinding('class.open') isOpen = false;
  suppressFocusOut: boolean;

  constructor() {
    this.suppressFocusOut = false;
  }

  @HostListener('click', ['$event'])
  toggleOpen(event: Event) {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
    this.suppressFocusOut = false;
  }

  @HostListener('mousedown', ['$event'])
  preventBlur(event: Event) {
    event.stopPropagation();
    if (!(<HTMLElement>event.target).classList.contains('dropdown-toggle')) {
      this.suppressFocusOut = true;
    }
  }

  @HostListener('focusout', ['$event'])
  toggleClose(event: Event) {
    event.stopPropagation();
    if (!this.suppressFocusOut && this.isOpen) {
      this.isOpen = !this.isOpen
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/dropdown.directive.ts